module.exports = __webpack_public_path__ + "static/top_left_image-adc85abadc8c918127f7b6c1d7a56055.png";